import { Filter } from '@spoiler-alert/ui-library';
import { makeAutoObservable } from 'mobx';

const localStorageKey = 'usersFilter';

type FilterTypes =
  | 'myClaims'
  | 'myPosts'
  | 'inventoryTable'
  | 'catalog'
  | 'negotiationsDetail'
  | 'offerComparison'
  | 'trucklane'
  | 'sellerReviewOffer'
  | 'stagingDetail'
  | 'donationsStagingDetail'
  | 'transactionHistory'
  | 'transactions'
  | 'suggestedNegotiations'
  | 'negotiationDetails';

class UserFiltersStore {
  filters: Record<FilterTypes, Filter[]> = JSON.parse(localStorage.getItem(localStorageKey) as string) || {};

  constructor() {
    makeAutoObservable(this);
  }

  updateFilters(name: FilterTypes, val: Filter[]): void {
    this.filters[name] = val;
    localStorage.setItem(localStorageKey, JSON.stringify(this.filters));
  }
}

export default UserFiltersStore;
